import React, { useMemo } from 'react';
import { Arrow, Group, Line } from 'react-konva';

import { ARROW_DASH, ARROW_RADIUS } from '@/features/canvas/constants';

type Point = {
  x: number;
  y: number;
};

type ArrowShapeProps = {
  source: Point;
  target: Point;
  fill?: string;
  opacity?: number;
};

const ArrowShape = React.memo(({ source, target, fill: strokeFill, opacity }: ArrowShapeProps) => {
  const dx = target.x - source.x;
  const dy = target.y - source.y;
  const angle = Math.atan2(-dy, dx);

  const arrowStart = useMemo(
    () => ({
      x: source.x + -ARROW_RADIUS * Math.cos(angle + Math.PI),
      y: source.y + ARROW_RADIUS * Math.sin(angle + Math.PI),
    }),
    [angle, source.x, source.y]
  );

  const arrowEnd = useMemo(
    () => ({
      x: target.x + -ARROW_RADIUS * Math.cos(angle),
      y: target.y + ARROW_RADIUS * Math.sin(angle),
    }),
    [angle, target.x, target.y]
  );

  const points = useMemo(
    () => [arrowStart.x, arrowStart.y, arrowEnd.x, arrowEnd.y],
    [arrowEnd.x, arrowEnd.y, arrowStart.x, arrowStart.y]
  );

  return (
    <Group>
      <Line points={points} strokeWidth={10} stroke="transparent" hitStrokeWidth={10} listening />

      <Arrow
        dash={ARROW_DASH}
        fill={strokeFill || '#6e6e72'}
        stroke={strokeFill || '#6e6e72'}
        strokeWidth={2}
        points={points}
        opacity={opacity ?? 1}
      />
    </Group>
  );
});

export { ArrowShape };
